<h1 mat-dialog-title>Edit Tags</h1>
<div mat-dialog-content>
    <p>
        Add or remove tags from the selected items. You can also edit the tags for your workspace in
        the
        <a href="/a/tags" target="_blank">Tag Settings</a>.
    </p>

    <div class="well">
        <h3>Tag Aggregate</h3>
        <p>
            These tags are present on at least one of the selected assets. You can Add [+] or Remove
            [-] any of these from the selected assets
        </p>
        <mat-slide-toggle (change)="intersectionChange()"
            >Only show tags that are present on <i>all</i> selected assets</mat-slide-toggle
        >
        <p></p>
        <div class="flex row justify-start">
            @for (tag of aggregate$ | async; track tag) {
                <frog-add-remove-tag [tag]="tag" (OnChange)="refresh()"></frog-add-remove-tag>
            }
        </div>
    </div>

    <div class="well">
        <h3>Changes</h3>
        <p>
            Only the tags here will be Added or Removed from the selection. Any other tags will not
            be changed
        </p>
        <div class="flex row justify-start">
            @for (tag of changes$ | async; track tag) {
                <frog-add-remove-tag [tag]="tag" (OnChange)="refresh()"></frog-add-remove-tag>
            }
        </div>
    </div>
    <frog-tag-input
        placeholder="Add Tag"
        actionPrefix="Add"
        [excludeCategories]="['artist']"
        (OnSelect)="add($event)"
    ></frog-tag-input>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button
        mat-stroked-button
        color="primary"
        [disabled]="(changes$ | async)?.length === 0"
        (click)="save()"
    >
        Save
    </button>
</div>
